import { render, staticRenderFns } from "./ReconciliationStep3-1.vue?vue&type=template&id=5c85afac&scoped=true&"
import script from "./ReconciliationStep3-1.vue?vue&type=script&lang=js&"
export * from "./ReconciliationStep3-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c85afac",
  null
  
)

export default component.exports